import styled from "styled-components";
import colors from "../constants/colors";
import { AiOutlineArrowRight } from "react-icons/ai";

export const PrimaryButton = styled.div`
  background-color: ${colors.red};
  padding: 16px 24px;
  color: #fff;
  border-radius: 4px;
  margin-right: 16px;
  margin-bottom: 16px;
  cursor: pointer;
  font-family: "Work Sans", sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 0em;
`;

const GeneralButton = styled.div`
  background-color: ${colors.red};
  padding: 16px 24px;
  color: #fff;
  border-radius: 4px;
  margin-bottom: 16px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Work Sans", sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 0em;
`;

export const PrimaryArrowButton = (props: any) => {
  return (
    <GeneralButton {...props}>
      {props.children}
      <AiOutlineArrowRight style={{ marginLeft: 4, fontSize: 18 }} />
    </GeneralButton>
  );
};

export const SecondaryButton = styled.div`
  border-color: ${colors.red};
  border-width: 1;
  padding: 16px 24px;
  color: ${colors.red};
  border-radius: 4px;
  border-style: solid;
  margin-right: 16px;
  margin-bottom: 16px;
  cursor: pointer;
  font-family: "Work Sans", sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 0em;
`;

export const LinkButton = styled.div`
  color: ${colors.red};
  cursor: pointer;
`;

export const UnderlinedLinkButton = styled.div`
  color: ${colors.red};
  cursor: pointer;
  text-decoration: underline;
  text-decoration-color: ${colors.red};
`;

export const RedUnderlineButton = styled.div`
  color: ${colors.red};
  cursor: pointer;
  text-decoration: underline;
  text-decoration-color: ${colors.red};
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;
`;
